import {BasicConstants} from "../basic/constants/BasicConstants";
export class TrackingConstants {

    public static TEST_TRACKING_SERVER: string = BasicConstants.DOMAIN_PROTOCOL + "://10.0.17.151:8443/" // currently macslave ws 007
    public static JSON_TRACKING_URL: string = BasicConstants.DOMAIN_PROTOCOL + "://http2.tracking.goodgamestudios.com/json-inbox.php";
}
